const protocol = require('@/api/protocol.js')

/**
 * translate
 *
 */
const translate = {}

translate.languagesCodes = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/languagesCodes'
    const method = 'get'
    const params = { }
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}
translate.languages = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/languages'
    const method = 'get'
    const params = { }
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

translate.isTranslable = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/isTranslable'
    const method = 'get'
    const params = { word: e.word, lng: e.lng}
    const data = getDataObject(e, params)
    protocol
        .call(path, method, data)
        .then(res => {
          return resolve(res)
        })
        .catch(err => {
          return reject(err)
        })
  })
}
translate.enToLng = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/english-to-lng'
    const method = 'get'
    const params = { word: e.word, lng: e.lng}
    const data = getDataObject(e, params)
    protocol
        .call(path, method, data)
        .then(res => {
          return resolve(res)
        })
        .catch(err => {
          return reject(err)
        })
  })
}
translate.enToFr = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/english-to-french'
    const method = 'get'
    const params = { word: e.word}
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}
translate.enToSp = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/english-to-spanish'
    const method = 'get'
    const params = { word: e.word}
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

function getDataObject (e, params) {
  const data = {}
  if (typeof e === 'object') {
    for (const [key, value] of Object.entries(e)) {
      data[key] = value
    }
    return data
  } else return {}
}
module.exports = translate
